













































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator'
import { APICountry } from '../../models/api/country.model'

@Component
export default class CarriersForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        typeId: {
            id: null
        },
        carrierEnabled: true
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        carrierName: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 50) || 'Field must be less than 50 characters'
        ]
    }

    formModel: { countries: APICountry[] } = {
        countries: []
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await this.getCountries()

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Carrier'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Carrier'
            this.data = {}
            this.loading = false
            break
        }
    }

    getCountries () {
        return new Promise(resolve => {
            this.$store.dispatch('getCountries')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.countries = this.$store.state?.CountriesStore?.countries?.map((p: APICountry) => {
                            return {
                                text: p.countryName,
                                value: p.countryId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getCarriersById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.CarriersStore.carrierForm
                    this.formData.countryId = this.formData.countryId.countryId
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editCarriers', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Carriers'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createCarriers', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Carriers'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
